var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app","data-dialog-id":"","data-loading-id":""}},[_c('router-view'),_c('mg-loading'),_c('mg-alert'),_c('mg-confirm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }